<template>
  <section>
    <div id="lotto">
      <div class="header">
        <img :src="lottoHeaderLeft" class="group-4" />
        <div class="text">
          <div class="desc">ยินดีด้วย</div>
          <div class="desc">คุณถูกรางวัลอันดับ 4</div>
          <div class="desc">เป็นเงินรางวัล 10,000 บาท</div>
        </div>
        <img :src="lottoHeaderRight" class="group-7" />
      </div>
      <div class="content">
        <div class="item st-price">
          <div class="desc-price">อันดับ 1</div>
          <div>1 ฉ 4023424</div>
        </div>
        <div class="item nd-price">
          <div class="desc-price">อันดับ 2</div>
          <div>1 ผ 8341146</div>
        </div>
        <div class="item">
          <div class="desc-price">อันดับ 3</div>
          <div class="list-lotto rd-price">
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
          </div>
        </div>
        <div class="item">
          <div class="desc-price">อันดับ 4</div>
          <div class="list-lotto n-th-price">
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
          </div>
        </div>
        <div class="item">
          <div class="desc-price">อันดับ 5</div>
          <div class="list-lotto n-th-price">
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
          </div>
        </div>
        <div class="item">
          <div class="desc-price">อันดับ 6</div>
          <div class="list-lotto n-th-price">
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
            <div>0185110</div>
          </div>
        </div>
      </div>
    </div>
    <ModalComming type="lotto" />
  </section>
</template>

<script>
import ModalComming from "../../../../components/miniapp/global/ModalComming";
export default {
  components: {
    ModalComming
  },
  data() {
    return {
      lottoHeaderLeft: `${process.env.VUE_APP_SCONTENT_URL}/line-liff/lotto-header-left.png`,
      lottoHeaderRight: `${process.env.VUE_APP_SCONTENT_URL}/line-liff/lotto-header-right@3x.png`
    };
  }
};
</script>

<style lang="scss" scoped>
#lotto {
  // display: table;
    filter: blur(4px);

  @extend %container-style;
  .header {

    font-family: DBHeaventRez;
    margin-top: 10px;
    position: relative;
    display: flex;
    justify-content: space-between;
    .group-4 {
      width: 105px;
      height: 120px;
      // object-fit: contain;
    }
    .group-7 {
      width: 76px;
      height: 120px;
      // object-fit: contain;
    }
    .text {
      .desc {
        text-align: center;
      }
      .desc {
        font-weight: bold;
      }
      .desc:first-child {
        font-size: 20px;
        color: $color-plus-lotto;
        font-weight: bold;
        //   background-color: yellow;
      }
      .desc:nth-child(2) {
        @extend %font-size-m;
        color: $color-plus-lotto;
        font-weight: bold;
        //   background-color: yellow;
      }
      .desc:last-child {
        @extend %font-size-s;
        font-weight: normal;
        color: $color-gray-inactive;
      }
    }
  }
  .content {
    min-height: 800px;
    border-radius: 4px;
    background-color: $highlight-grey-lotto;
    margin: 10px 0;
    .item {
      text-align: center;
      display: flex;
      flex-direction: column;
      border-bottom: 1px solid $color-light-grey-2;
      padding: 20px;
      margin-left: 15px;
      margin-right: 15px;
      .desc-price {
        @extend %font-size-s;
        font-weight: bold;
      }
      .list-lotto {
        color: $color-normal-text;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
      }
      .rd-price {
        @extend %font-size-s;
        div {
          @include multipleResponsive(phablet, tablet) {
            width: 20%;
          }
          width: 30%;
        }
      }
      .n-th-price {
        div {
          @include multipleResponsive(phablet, tablet) {
            width: 20%;
          }
          @extend %font-size-ss;
          width: 20%;
        }
      }
    }
  }
}
</style>